<template>
	<div ref="echartCustomanaly" style="width:100%;height:100%;">
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default {
		name: 'echartCustomanaly',
		props: {
			echartanalydata: {
				type: Array,
				default: []
			}
			

		},
		data() {
			return {}
		},
		mounted() {
			this.getEchart();
			window.addEventListener('resize', this.resize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize)
		},
		watch: {
			echartanalydata(n, o) {
				this.$nextTick(() => {
					this.getEchart();
				});
			},
		},
		methods: {
			resize(){
				this.myChart.resize()
			},
			getEchart() {
				this.myChart = echarts.init(this.$refs.echartCustomanaly)
				this.legend = []
				this.series = []
				this.echartanalydata.map(t => {
					this.legend.push(t.Name)
					let series = {
						name: t.Name,
						type: 'bar',
						data: t.value,
						stack: '总量',
						// smooth: true,
						label: {
							normal: {
								show: true,
								position: 'insideRight'
							}
						},
					}
					if(t.Name == '新客户'){
						series.itemStyle = {
							normal: {
							    color: '#60acfc',
							    lineStyle: {
							        color: '#60acfc'
							    }
							}
						}
					}
					
					if(t.Name == '老客户'){
						series.itemStyle = {
						  normal: {
						      color: '#30f643',
						      lineStyle: {
						          color: '#30f643'
						      }
						  }
						}
					}
					this.series.push(series)
				})
				
				// console.log(this.series,'看到底对不对88888')
				let option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: {
						data:this.legend
					},
					grid: {
						left: '2%',
						top: '15%',
						right: '3%',
						bottom: '4%',
						containLabel: true
					},
					xAxis: {
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						type: 'value',
						axisLabel: {
							show: false
						},
					},
					yAxis: {
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						type: 'category',
						data: ['0-50元', '50-100元', '100-150元', '150-200元', '200-250元', '250-300元','300-350元','350-400元','400-450元','450-500元','500-1000元','1000-1500元','1500-2000元','2000-2500元','2500-3000元','3000-3500元','3500-4000元','4000-4500元','4500-5000元','5000元以上'],
					},
					series:this.series
				};
				this.myChart.setOption(option,true);
			}
		}
	}
</script>

<style>
</style>
